/**
 * GeChiUI dependencies
 */
import { useContext } from '@gechiui/element';

/**
 * Internal dependencies
 */
import { Context } from './context';

export default function useAsyncMode() {
	return useContext( Context );
}
